export default "__VITE_ASSET__9WIRJXhf__"